import { SetWallboardType } from "../action-types/wallboard.action.types";

export const SetWallboard = (message: any) => {
  return {
    type: SetWallboardType.SET_WALLBOARD,
    payload: message,
  };
};
